// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"styles_tabWrapper__2dqxr","count":"styles_count__20iNW","tabActive":"styles_tabActive__qxUlF"};